export default __webpack_public_path__ + "static/media/logo-Global-Net4.4b34b7b3.png";